import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'model/State';
import {
  OrderCenterPaginationProps,
  OrderCenterTableItems,
  OrdersPage,
  OrdersPageProps,
} from './OrdersPage';
import { selectInvoices } from './duck/selectors';
import { fetchSearchForContactPost } from './duck/actions/invoices';

// this component can be used to show a particular order
// and scrolled into view port using URL: `/purchase/my/orders/{orderId}?hash=:hash`
export const MACInvoicesPage = (props: Pick<OrdersPageProps, 'orderId'>) => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState<OrderCenterPaginationProps>({
    maxResult: 10,
    offset: 0,
    totalItems: 10,
  });

  const invoices = useSelector(
    (state) => selectInvoices(state as State)?.results || null,
  ) as OrderCenterTableItems;

  const totalResults = useSelector((state) => selectInvoices(state as State)?.totalAvailable || 0);

  useEffect(() => {
    if (totalResults > 0) {
      setPagination({
        ...pagination,
        totalItems: totalResults,
      });
    }
  }, [totalResults]);

  const handlePaginationChange = (params: { offset?: number }) => {
    setPagination({
      ...pagination,
      offset: params.offset || 0,
    });
    dispatch(fetchSearchForContactPost(pagination.maxResult, params.offset || 0));
  };

  return (
    <OrdersPage
      items={invoices}
      pagination={pagination}
      onPaginationChange={handlePaginationChange}
      {...props}
    />
  );
};
